import React, { useState } from "react";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Lesson } from "../../types/Lessons";
import MoreMenu from '../Shared/MoreMenu';
import ConfirmDialog from '../Shared/ConfirmDialog';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Api from "../../network/Api";
import EditIcon from '@mui/icons-material/Edit';

const ActionMenu = (props: { lesson: Lesson, editable?: boolean, onEdit: () => void } ) => {

  const [showConfirm, shouldConfirm] = useState<boolean>(false);

  const destroy = () => {
    shouldConfirm(false);
    Api.delete(`/lessons/${props.lesson.id}`).then(() => window.location.reload());
  }

  return <>
    <MoreMenu>
      <MenuItem disabled={!props.editable} onClick={props.onEdit}>
        <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
        <ListItemText>Edit mode</ListItemText>
      </MenuItem>

      <MenuItem onClick={() => shouldConfirm(true)}>
        <ListItemIcon><DeleteOutlineIcon fontSize="small" /></ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </MoreMenu>

    { showConfirm && <ConfirmDialog title="Delete lesson" 
                                    message="Do you really want to permanently delete this lesson learned?"
                                    destructive
                                    onCancel={() => shouldConfirm(false)}
                                    onConfirm={destroy} /> }
  </>
}

export default ActionMenu;